module.exports = __webpack_public_path__ + "static/haven2-2b6f5f378050a1997d54e41ce20a8a41.jpg";